import * as React from 'react';
import { withRouteData } from 'react-static';
import { graphql, ChildDataProps } from 'react-apollo';

import NetworksPageComponent from '../../components/NetworksPage/NetworksPage';
import { NetworksPageLocale } from '../../components/NetworksPage/networksPage.locale';
import { Query, Network } from '../../GraphQL';

import networksQuery from './networksQuery.gql';

interface RouteProps {
  locale: NetworksPageLocale;
  networks: Network[];
}

interface NetworksPageProps extends RouteProps, ChildDataProps<RouteProps, Query> {}

const NetworksPage: React.SFC<NetworksPageProps> = ({ locale, networks, data }) => (
  <NetworksPageComponent locale={locale} networks={data.networks || networks} />
);

export default withRouteData(
  graphql<RouteProps, Query, {}, NetworksPageProps>(networksQuery)(NetworksPage),
);



// WEBPACK FOOTER //
// /www/client/src/containers/NetworksPage/NetworksPage.tsx